var React = require('react');

function BrandIconLight (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.77","y":"119.55","width":"99.51","height":"8.52","key":0}),React.createElement("path",{"d":"M101.28,65.36v-1c0,.18,0,.36,0,.54,0-1.54-.08-3.07-.19-4.58A63.37,63.37,0,0,0,96.78,42a64.13,64.13,0,0,0-3.44-7.31,63.5,63.5,0,0,0-90.86-22L10,17.32,26.4,27.54,1.77,83.19,19.3,92.12,59.13,73.6V50.79H50.7v18L19.3,83l-7-3.64L36.65,23.9,18.73,13.24A55.51,55.51,0,0,1,93.34,64.93v0c0,.15,0,.29,0,.44s0,.3,0,.44v37.83H1.77v8.72h99.51v-47Z","key":1})]);
}

BrandIconLight.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 101.28 130.4","fill":"#ffffff"};

module.exports = BrandIconLight;

BrandIconLight.default = BrandIconLight;
